const Loader = ()=>{
    return (
        <>
        <div className="lds-hourglass"></div> 
        </>
    )
}
export default Loader;